import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";

import BasePaper from "components/Base/BasePaper";
import DiscipleshipPeopleMovementTab from "pages/community/DiscipleshipPathway/DiscipleshipPathwayBottomDrawer/DiscipleshipPeopleMovementTab";

import {
  getNodePeople,
  moveItemsBetweenNodes,
} from "api/Community/DiscipleshipPathwayAPI";
import SelectARecordToView from "components/Records/SelectARecordToView";

interface DiscipleshipPathwayBottomDrawerProps {
  selectedNode: any | null;
}

const DiscipleshipPathwayBottomDrawer: React.FC<
  DiscipleshipPathwayBottomDrawerProps
> = ({ selectedNode }) => {
  const [nodeData, setNodeData] = useState<any | null>(null);

  useEffect(() => {
    setNodeData(selectedNode ? { ...selectedNode } : null);
  }, [selectedNode]);

  if (!selectedNode) {
    return <SelectARecordToView itemName="node" message="Select a Discipleship Stage  to view details" maxHeight={150}/>;
  }
  
  return (
    <BasePaper>
      <DiscipleshipPeopleMovementTab
        nodeData={nodeData}
        getNodePeople={getNodePeople}
        movePeopleBetweenNodes={moveItemsBetweenNodes}
      />
    </BasePaper>
  );
};

export default DiscipleshipPathwayBottomDrawer;